export default __webpack_public_path__ + "static/media/termos_de_uso_enfuroped.f6634cd0.pdf";